const $skuForm = document.querySelector('.js-sku-generator-form');
const $generatSkuButton = document.querySelector('.js-btn-generate-sku');
const $resultTable = document.querySelector('.js-sku-table');
const $btnGenerateCsv = document.querySelector('.js-btn-generate-csv');
const exampleTable = '.js-table-data-example';

const DEFAULT_PARAMS = {
    characters: 3,
    separator: '',
    uppercase: true
}

// Enable action to remove row from table
function enableRemoveControl() {
    const $removeBtn = document.querySelectorAll('.js-remove-row');

    $removeBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            btn.parentElement.parentElement.remove();

            if(!$resultTable.querySelector('td')) {
                $btnGenerateCsv.setAttribute('disabled', 'disabled');
            }
        })
    })
}

// Check if example table data exists
// @param removeExample Boolean - if true remove element
function checkExampleTableDataAndRemove(removeExample) {
    const $example = document.querySelector(exampleTable);
    if($example && removeExample) {
        $example.remove();
        return;
    }

    return $example ? true : false;
}

// Sanitize string
function sanitizeString(str) {
    str = str.replace(/^\s+|["']|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaeeeeiiiioooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '')
        .replace(/-+/g, '');

    return str;
}

// Generate a <tr> with custom data
// Last item can be the generated SKU
function generateTableRow(content = []) {
    if(checkExampleTableDataAndRemove()) {
        checkExampleTableDataAndRemove(true);
    }

    if(exportButtonIsDisabled()) {
        $btnGenerateCsv.removeAttribute('disabled');
    }

    let tr = document.createElement('tr');

    content.forEach((item, key) => {
        const isHiddenXs = [0, 4].includes(key) ? 'c-mid-gray' : 'c-mid-gray hidden-xs';
        tr.innerHTML += '<td class="'+isHiddenXs+'">'+item+'</td>';
    })

    tr.innerHTML += '<td><button type="button" class="js-remove-row square-icon-50 flex background-color-danger square-icon-40 btn flex strong">'+close_icon+'</button></td>'

    $resultTable.querySelector('tbody').appendChild(tr);

    enableRemoveControl();
}

// Generate SKU
function generateSku(productName, option1, option2, option3, params = DEFAULT_PARAMS) {
    const { characters, separator, uppercase } = params

    const skuGenerated =
        sanitizeString(productName).slice(0, characters) + (separator != '' ? separator : '') +
        sanitizeString(option1).slice(0, characters) + (separator != '' ? separator : '') +
        sanitizeString(option2).slice(0, characters) + (separator != '' ? separator : '') +
        sanitizeString(option3).slice(0, characters);

    let output = skuGenerated;

    if(uppercase) {
        output = sanitizeString(skuGenerated).toUpperCase();
    }

    return output;
}

// Generate values and data
function handleGenerate() {
    const data = new FormData($skuForm);

    const formValues = {
        productName: data.get('productName'),
        option1: data.get('option1'),
        option2: data.get('option2'),
        option3: data.get('option3')
    };

    formValues.skuGenereated = generateSku(formValues.productName, formValues.option1, formValues.option2, formValues.option3);

    generateTableRow(Object.values(formValues));
    return;
}

// Method to generate CSV from table
function generateCsvFromTable() {
    const $rows = $resultTable.querySelectorAll('tr');

    let csvContent = '';

    $rows.forEach((row) => {
        const cells = row.querySelectorAll('td, th');
        const rowContent = [];

        cells.forEach((cell, key) => {
            if(key != 5) {
                rowContent.push('"' + cell.textContent.replace(/"/g, '""').trim() + '"');
            }
        });

        csvContent += rowContent.join(',') + '\n';
    });

    const blobContent = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blobContent);
    link.download = 'sku-generator.csv';
    link.click();
}

// Check if export button is disabled
function exportButtonIsDisabled() {
    const isDisabled = $btnGenerateCsv.getAttribute('disabled') != null;

    if(isDisabled) return true;
    return false;
}

// Subscribe method
async function handleSubmitSubscribeForm(callback) {
    if( !$.cookie('tool_' + landing + '_subscribe_modal_gate') && HUBSPOT_FORM_EMBED.currenStep() != '1') {
        toolsSubscribe();

        $('#modal-subscribe').modal('show');
        amplitude_log_event('tools_' + landing + '_modal', {
            'state': 'opened'
        });

        document.addEventListener('onHubspotFormSubmit', function (params) {
            $('#modal-subscribe').modal('hide');
            amplitude_log_event('tools_' + landing + '_modal', {
                'state': 'closed'
            });

            $.cookie('tool_' + landing + '_subscribe_modal_gate', true, { expires: 30, path: '/' });

            $('#modal-subscribe').on('hidden.bs.modal', callback);

            amplitude_log_event('tools_subscribed', {
                'tool_name': landing
            });
        })

    } else {
        callback();
    }
}

// Handle generate method when submit form
$skuForm.addEventListener('submit', (e) => {
    e.preventDefault();
    handleGenerate();
});

// Handle csv export at button click
$btnGenerateCsv.addEventListener('click', (e) => {
    e.preventDefault();

    const hasContentOnTable = $resultTable.querySelector('td') && !checkExampleTableDataAndRemove();

    if(hasContentOnTable) {
        handleSubmitSubscribeForm(generateCsvFromTable);
    } else {
        $skuForm.querySelector('input').focus()
    }
});
